import React, { Component } from "react";
import { Navbar, NavDropdown } from "react-bootstrap";
import SettingsIcon from "@material-ui/icons/Settings";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { logout } from "../services/Auth";
import { getUser } from "../services/Auth";

import logoSvg from "../assets/logotipo-ifeira.svg";

export default class Header extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      status: null,
      user: null,
    };
  }

  async handleLogout() {
    await logout();
    await window.location.reload();
  }

  async componentDidMount() {
    const user = await getUser();
    this.setState({
      user,
    });
  }

  render() {
    return (
      <Navbar expand="lg" style={{ backgroundColor: "white !important" }}>
        <Navbar.Brand href="#/app">
          <img
            alt=""
            src={logoSvg}
            className="d-inline-block align-top"
            width="75px"
            style={{ marginLeft: 25 }}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse className="justify-content-end">
          <NavDropdown
            title={<SettingsIcon></SettingsIcon>}
            id="collasible-nav-dropdown"
          >
            <NavDropdown.Item onClick={() => this.handleLogout()}>
              <ExitToAppIcon></ExitToAppIcon>
              Sair
            </NavDropdown.Item>
          </NavDropdown>
        </Navbar.Collapse>
      </Navbar>
    );
  }
}
